/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";
import { performFetch, setApplicationLocalStorageItem } from "../../helpers";
import store from "../store";

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  async fetchUsers({ commit }) {
    return new Promise(async (resolve, reject) => {
      // fetch(store.state.auth.api_url, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_application_users",
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(store.state.auth.api_url, {
        command: "get_application_users",
        parameters: {
          application_token: store.state.auth.app_token,
          session_token: store.state.auth.token
        }
      })
      .then(async response => {
        // commit('SET_USERS', response.data)
        // resolve(response)
        if (response.status === 200) {
          await response.json().then(async response => {
            response.users.forEach((item, key) => {
              item.avatar = item.photo;
              return item;
            });
            response.users = response.users.filter(el => el.active === true);

            commit("SET_USERS", response.users);
            resolve(response);
          });
        } else if (response.status === 401) {
          setApplicationLocalStorageItem(
            "lastUrl",
            btoa(window.location.pathname)
          );
          store.dispatch("auth/signOut");
        }
      });
      // .catch((error) => { reject(error) })

      // axios.get('/api/user-management/users')
      //   .then((response) => {
      //     console.log(response.data)
      //     commit('SET_USERS', response.data)
      //     resolve(response)
      //   })
      //   .catch((error) => { reject(error) })
    });
  },
  fetchApplicationData({ commit, dispatch }, payload) {
    return new Promise(async (resolve, reject) => {
      // fetch(payload.apiUrl, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_application_settings_detail",
      //     parameters: {
      //       application_token: payload.appToken,
      //       session_token: payload.userSession
      //     }
      //   })
      // })
      await performFetch(payload.apiUrl, {
        command: "get_application_settings_detail",
        parameters: {
          application_token: payload.appToken,
          session_token: payload.userSession
        }
      })
        .then(async response => {
          if (response.status === 200) {
            await response.json().then(async response => {
              resolve(response.settings);
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            store.dispatch("auth/signOut");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setApplicationData({ commit }, payload) {
    commit("SET_APPLICATION_DATA", payload);
  },
  // fetchUser (context, userId) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`/api/user-management/users/${userId}`)
  //       .then((response) => {
  //         console.log(response)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchUser({ commit }, userHash) {
    return new Promise(async (resolve, reject) => {
      // fetch(store.state.auth.api_url, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_application_user_detail",
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token,
      //       user_hash: userHash
      //     }
      //   })
      // })
      await performFetch(store.state.auth.api_url, {
        command: "get_application_user_detail",
        parameters: {
          application_token: store.state.auth.app_token,
          session_token: store.state.auth.token,
          user_hash: userHash
        }
      })
        .then(async response => {
          if (response.status === 200) {
            await response.json().then(async response => {
              commit("setUserEditName", response.user.name);
              commit("setUserEditEmail", response.user.email);
              commit("setUserEditMobile", response.user.mobile);
              commit("setUserEditRole", response.user.role.hash);
              commit("setUserEditRoleObject", response.user.role);
              commit("setUserEditStatusId", response.user.status_id);
              commit("setUserEditIsAdmin", response.user.is_admin);
              commit("setUserEditLanguages", response.user.languages);
              resolve(response.user);
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            store.dispatch("auth/signOut");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  validBase64({}, str) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (str) {
          if (str.substring(0, 4) !== "http") {
            resolve(/[A-Za-z0-9+/=]/.test(str));
          } else {
            resolve(false);
          }
        }
      }, 300);
    });
  },
  async saveChanges({ commit, dispatch, state }, payload) {
    return new Promise(async (resolve, reject) => {
      // fetch(payload.apiUrl, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "update_application_settings",
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token,
      //       settings: {
      //         favicon: state.settings.favicon,
      //         footer: state.settings.footer,
      //         web_tab_name: state.settings.tabName,
      //         telegram_bot_token: state.settings.telegramBotToken,
      //         logical_exclusion: state.settings.logicalExclusion,
      //         telegram_user_welcome_message:
      //           state.settings.telegramWelcomeMessage,
      //         users_can_simultaneous_sessions:
      //           state.settings.simultaneousSessions,
      //         tab_title: state.settings.tabTitle,
      //         title: state.settings.title,
      //         subtitle: state.settings.subtitle,
      //         username_label: state.settings.usernameLabel,
      //         password_label: state.settings.passwordLabel,
      //         submit_button_label: state.settings.submitButtonText,
      //         forgot_label: state.settings.forgotLabel,
      //         logo: state.settings.logo,
      //         card_logo: state.settings.cardLogo,
      //         background: state.settings.background,
      //         forgot_password_title: state.settings.forgotPasswordTitle,
      //         forgot_password_email_label:
      //           state.settings.forgotPasswordEmailLabel,
      //         forgot_password_button_label:
      //           state.settings.forgotPasswordButtonLabel,
      //         email_sender_driver_type_id:
      //           state.settings.emailSenderDriverTypeId,
      //         email_sender_host: state.settings.emailSenderHost,
      //         email_sender_port: state.settings.emailSenderPort,
      //         email_sender_from_name: state.settings.emailSenderFromName,
      //         email_sender_from_address: state.settings.emailSenderFromAddress,
      //         email_sender_username: state.settings.emailSenderUsername,
      //         email_sender_password: state.settings.emailSenderPassword,
      //         api_delegator: state.settings.apiDelegator,
      //         api_token: state.settings.apiIntegrationToken
      //       }
      //     }
      //   })
      // })
      await performFetch(payload.apiUrl, {
        command: "update_application_settings",
        parameters: {
          application_token: store.state.auth.app_token,
          session_token: store.state.auth.token,
          settings: {
            favicon: state.settings.favicon,
            footer: state.settings.footer,
            web_tab_name: state.settings.tabName,
            telegram_bot_token: state.settings.telegramBotToken,
            logical_exclusion: state.settings.logicalExclusion,
            telegram_user_welcome_message:
              state.settings.telegramWelcomeMessage,
            users_can_simultaneous_sessions:
              state.settings.simultaneousSessions,
            tab_title: state.settings.tabTitle,
            title: state.settings.title,
            subtitle: state.settings.subtitle,
            username_label: state.settings.usernameLabel,
            password_label: state.settings.passwordLabel,
            submit_button_label: state.settings.submitButtonText,
            forgot_label: state.settings.forgotLabel,
            logo: state.settings.logo,
            card_logo: state.settings.cardLogo,
            background: state.settings.background,
            forgot_password_title: state.settings.forgotPasswordTitle,
            forgot_password_email_label:
              state.settings.forgotPasswordEmailLabel,
            forgot_password_button_label:
              state.settings.forgotPasswordButtonLabel,
            email_sender_driver_type_id:
              state.settings.emailSenderDriverTypeId,
            email_sender_host: state.settings.emailSenderHost,
            email_sender_port: state.settings.emailSenderPort,
            email_sender_from_name: state.settings.emailSenderFromName,
            email_sender_from_address: state.settings.emailSenderFromAddress,
            email_sender_username: state.settings.emailSenderUsername,
            email_sender_password: state.settings.emailSenderPassword,
            api_delegator: state.settings.apiDelegator,
            api_token: state.settings.apiIntegrationToken
          }
        }
      })
        .then(async response => {
          if (response.status === 200) {
            await response.json().then(async response => {
              resolve(response);
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            store.dispatch("auth/signOut");
          } else {
            reject(Error("Internal Server Error"));
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/user-management/users/${userId}`)
        .then(response => {
          commit("REMOVE_RECORD", userId);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
